module.exports = __webpack_public_path__ + "img/18_92.66dcb98a.png";